export default __webpack_public_path__ + "static/media/lastline.f97457b8.png";